/*
 * Custom Bundle Timer — fixed-duration countdown that loops infinitely,
 * synced to the wall clock (so it's consistent across reloads). Used for the
 * "Bundle Offers reserved for:" 15-minute rolling timer.
 */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  document.querySelectorAll('[data-cbs-timer]').forEach(function (root) {
    var dur = parseInt(root.getAttribute('data-duration'), 10) || 900;
    var hEl = root.querySelector('[data-h]');
    var mEl = root.querySelector('[data-m]');
    var sEl = root.querySelector('[data-s]');
    if (!hEl || !mEl || !sEl || dur <= 0) { return; }

    function tick() {
      var nowSec = Math.floor(Date.now() / 1000);
      var remaining = dur - (nowSec % dur); // rolling countdown to the next boundary
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  });
})();
